import { Sector, Parameter } from '@gameonly/core';

export const flattenParameters = (sectors: Sector[]): Parameter[] =>
    sectors.reduce((allParameters, sector) => {
      const subParameters = flattenParameters(sector.sectors);
  
      return [...allParameters, ...sector.parameters, ...subParameters];
    }, [] as Parameter[]);

export const getParameterFromId = (sectors: Sector[] | undefined, id: string) => {
  if (!sectors) return undefined;
  const parameters = flattenParameters(sectors);
  return parameters.find((parameter) => parameter.id === id);
};

export const getIsCNC = (sectors: Sector[]) => {
  const cncParam = getParameterFromId(sectors, 'objectif_formulaire');
  return (cncParam?.value as string)?.includes('CNC') || false;
};
